<template>
  <div class="copywrite">
    <p>©️2023 Altschooler ---- Rasheed Olatunde</p>
  </div>
</template>

<script>
export default {};
</script>

<style>
.copywrite {
  height: 10vh;
  background: #a5cfed;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4a9edb;
}
.copywrite > p {
  font-size: 20px;
}
</style>
